export default __webpack_public_path__ + "static/media/KOL-SANDRA DEWI.23db5f0f.jpg";